import Vue from 'vue';
import App from './App';
import Mint from 'mint-ui';
import Meta from 'vue-meta';
import animated from 'animate.css'; // animate动画库安装
import VueWechatTitle from 'vue-wechat-title'; // 每个子页面添加标题
import VueAwesomeSwiper from 'vue-awesome-swiper';
// import Share from 'vue-social-share'
import '../../assets/css/reset.min.css'; // 导入初始css
import 'lib-flexible/flexible';
import 'mint-ui/lib/style.css';
// import eruda from 'eruda';


import store from '../../store/active';
import router from '../../router/hjwq';

Vue.config.productionTip = false;
Vue.prototype.$bus = new Vue();
Vue.use(Mint);
Vue.use(VueWechatTitle);
Vue.use(animated);
Vue.use(VueAwesomeSwiper);
Vue.use(Meta);
// Vue.use(Share)
Vue.config.ignoredElements = ['wx-open-launch-weapp']

// let el = document.createElement('div');
// document.body.appendChild(el);

// eruda.init({
//   container: el,
//   useShadowDom: true
// });

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/pages/hjwq/hjwq.js